import React from "react";
import { View } from "react-native";
import { registrationStyles as styles } from "../styles/registrationStyles";
import HeaderBack from "../component/HeaderBack";

const UserAddress = () => {
  return (
    <View style={styles.container}>
      <HeaderBack title="Addresses" />
    </View>
  );
};

export default UserAddress;
